import { render } from "./queryWaybill.vue?vue&type=template&id=71fef352&scoped=true&scroll=no&style=overflow%20%3Ainitial"
import script from "./queryWaybill.vue?vue&type=script&lang=js"
export * from "./queryWaybill.vue?vue&type=script&lang=js"

import "./queryWaybill.vue?vue&type=style&index=0&id=71fef352&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fef352"]])

export default __exports__